<div class="hm-search">
  <div class="hm-search-tabs" role="tablist" aria-label="Search type">
    <button
      *ngFor="let tab of tabs; let i = index"
      [id]="'hm-search-tab-' + tab.id"
      role="tab"
      [attr.aria-selected]="tab === activeTab"
      [attr.tabindex]="tab === activeTab ? 0 : -1"
      [class.active]="tab === activeTab"
      (click)="selectTab(tab)"
      (keydown)="onTabKeydown($event, i)"
      type="button"
    >
      {{ tab.label }}
    </button>
  </div>
  <div class="hm-search-row">
    <label class="hm-search-input">
      <span class="visually-hidden">Search registrations</span>
      <mat-icon aria-hidden="true" data-nosnippet>search</mat-icon>
      <input
        type="text"
        [placeholder]="placeholder"
        [(ngModel)]="term"
        (keydown.enter)="submit()"
      />
    </label>
    <button class="hm-btn hm-btn--green" type="button" (click)="submit()">
      Search
    </button>
  </div>
  <div class="hm-search-plate" *ngIf="plateMatch as reg">
    <button type="button" (click)="goToPlate()">
      Go to the <strong>{{ reg }}</strong> plate page<span aria-hidden="true">→</span>
    </button>
    <span class="hm-search-plate-or">or press Search for plates like {{ term.trim() }}</span>
  </div>
</div>
